<template>
  <v-dialog
    v-model="showUserRegistrationRequiredDialog"
    max-width="500px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="primary white--text">
        <h3 class="headline mb-0">{{ $t('texts.pleaseLogIn') }}</h3>
        <v-spacer/>
        <v-btn
          text small fab
          @click="showUserRegistrationRequiredDialog = false"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-xl>
          <v-row>
            <v-col :cols="12">
              {{ $t('texts.functionOnlyLoggedInAvailable') }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-3">
        <v-btn color="primary" class="white--text" @click="showUserRegistrationDialog()">
          {{ $t("texts.register") }}
        </v-btn>
        <v-spacer/>
        <v-btn color="primary" class="white--text" @click="showUserLoginDialog()">
          {{ $t('texts.login') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UserRegistrationRequiredDialog',
  data() {
    return {
      showUserRegistrationRequiredDialog: false,
    };
  },
  mounted() {
    this.$eventBus.$on('show-user-registration-required-dialog', () => {
      this.showUserRegistrationRequiredDialog = true;
    });
  },
  methods: {
    showUserLoginDialog() {
      this.showUserRegistrationRequiredDialog = false;
      this.$eventBus.$emit('show-user-login-dialog');
    },
    showUserRegistrationDialog() {
      this.showUserRegistrationRequiredDialog = false;
      this.$eventBus.$emit('show-user-registration-dialog');
    },
  },
};
</script>
